// @flow
import * as React from 'react';
import { connect } from 'react-redux';
import _, { get } from 'lodash';
import { withRouter } from "react-router-dom";
import { formValueSelector } from "redux-form";
import { Redirect } from 'react-router-dom';
import getLeagueStartRounds from '../../../modules/selectors/getLeagueStartRounds';
import Preloader from '../../Preloader';
import * as actions from "../../../modules/actions";
import * as selectors from "../../../modules/selectors";
import {
	TextModal, RemoveConfirmationModal, AlertScreen, OneColumnLayout
} from '../../../components';

type Props = {
	match: Object,
	createDraftLeague: typeof actions.leagueDraft.createDraftLeague,
	updateDraftLeague: typeof actions.leagueDraft.updateDraftLeague,
	removeDraftLeague: typeof actions.leagueDraft.removeDraftLeague,
	clearDraftLeagueCreateErrors: typeof actions.leagueDraft.clearDraftLeagueCreateErrors,
	clearDraftLeagueUpdateErrors: typeof actions.leagueDraft.clearDraftLeagueUpdateErrors,
	league: Object,
	getLeagueStartRounds: Function,
	rounds: Array<Object>,
	selected_round_id: number,
	league_id: number,
	fetchRounds: typeof actions.rounds.fetchRounds,
	children: Function,
	toggleForm: Function,
	showDraftLeague: typeof actions.leagueDraft.showDraftLeague,
	from: string,
	league_update: {
		error: string,
		is_pending:boolean
	},
	league_create: {
		error: string,
		league_id:number
	},
	league_error?: string,
	remove_league_success: boolean,
	actual_round: Object,
}

type State = {
	file: Object,
	previewImg: string,
	is_show_advanced_settings: boolean,
	league_removed: boolean,
	show_remove_modal: boolean,
	league_updated: boolean,
}

class LeagueManager extends React.Component<Props, State> {
	state = {
		is_show_advanced_settings: false,
		previewImg: '',
		file: {},
		is_bye: 0,
		from: 'create',
		league_removed: false,
		league_updated: false,
		show_remove_modal: false,
	};

	constructor(props, state) {
		super(props, state);

		_.bindAll(this, [
			'handleCreateSubmit',
			'handleUpdateSubmit',
			'onChangeFile',
			'toggleForm',
			'removeLeague',
			'handleErrorModalClose',
			'confirmRemoveLeague',
			'closeErrorModal',
		]);
	}

	handleCreateSubmit(values) {
		// draft_start is moment object (react-datetime return moment object)
		if (typeof (values.draft_start) !== 'string') {
			values.draft_start = values.draft_start.format('YYYY-MM-DD[T]HH:mm:ss');
		}

		const
			{ file } = this.state,
			{ createDraftLeague } = this.props,
			data = { ...values, avatar: file };

		const new_league = createDraftLeague(data);

		if(!get(new_league, 'error')) {
			console.log('success');
		}
	}

	handleUpdateSubmit(values) {
		if (typeof (values.draft_start) !== 'string') {
			values.draft_start = values.draft_start.format('YYYY-MM-DD[T]HH:mm:ss');
		}
		const { league: { status, draft_status } } = this.props;
		let redundant_keys = [];

		if (draft_status !== 'scheduled') {
			redundant_keys = _.concat(
				redundant_keys, ['draft_order', 'draft_type', 'draft_turn', 'draft_start']
			);
		}
		if (status !== 'scheduled') {
			redundant_keys = _.concat(
				redundant_keys, ['start_round']
			);
		}
		let data_to_send = _.omit({ ...values }, redundant_keys);

		const
			{ file } = this.state,
			{ updateDraftLeague } = this.props,
			data = {
				...data_to_send,
				avatar: file
			};

		const updated_league = updateDraftLeague(data);

		if(!get(updated_league, 'error')) {
			this.setState({ league_updated: true });
		}

	}

	removeLeague(e) {
		e.preventDefault();
		this.setState({ show_remove_modal: true });
	}

	get error_modal() {
		const { league_update, league_create } = this.props;

		return (
			<TextModal
				onClick={this.handleErrorModalClose}
				header_text='Error'
				text={
					league_update.error ?
						league_update.error :
						league_create.error
				} />
		);
	}

	get remove_modal() {
		return (
			<RemoveConfirmationModal
				header_text='CONFIRM LEAGUE REMOVAL'
				body_text='Are you sure you want to
				remove this league? You will not be able to recover once deleted.'
				confirmClick={this.confirmRemoveLeague}
				cancelClick={this.closeErrorModal}
				closeClick={this.closeErrorModal}
			/>
		);
	}

	get updated_modal() {
		const { league_update } = this.props,
			{ league_updated } = this.state;
		return (!league_update.is_pending && !league_update.error && league_updated) ? (
			<TextModal
				onClick={() => {
					this.setState({ league_updated: false });
				}}
				header_text='League Settings'
				text='Your League settings have now been updated!' />
		):null;
	}

	closeErrorModal() {
		this.setState({ show_remove_modal: false });
	}

	confirmRemoveLeague() {
		const { removeDraftLeague, league } = this.props;
		const league_removed = removeDraftLeague(league);
		console.log(league_removed);
		this.setState({ league_removed: Boolean(league_removed) });
	}

	handleErrorModalClose() {
		const { from } = this.props;
		const { clearDraftLeagueCreateErrors, clearDraftLeagueUpdateErrors } = this.props;

		if(from === 'create') {
			clearDraftLeagueCreateErrors();
		}
		else {
			this.setState({ league_updated: false });
			clearDraftLeagueUpdateErrors();
		}
	}

	componentDidMount() {
		const {
			fetchRounds,
			from,
			clearDraftLeagueCreateErrors,
		} = this.props;

		clearDraftLeagueCreateErrors();

		if(from === 'update') {
			const {
				match: { params: { league_id } },
				showDraftLeague,
			} = this.props;

			showDraftLeague({ id: league_id });
		}

		fetchRounds();
	}

	getRoundOptions() {
		const { rounds } = this.props;

		return _.map(rounds, round => ({
			value: round.id,
			text: `ROUND ${round.id}`,
		}));
	}

	onChangeFile(e) {
		const
			reader = new FileReader(),
			file = e.target.files[0];

		reader.onload = e => {
			this.setState({ previewImg: e.target.result });
		};

		reader.readAsDataURL(file);

		this.setState({ file });
	}

	toggleForm(is_show_advanced_settings) {
		this.setState({ is_show_advanced_settings });
	}

	get handler_name() {
		const { from } = this.props;

		return {
			create: this.handleCreateSubmit,
			update: this.handleUpdateSubmit,
		}[from];
	}

	get should_redirect_to_leagues() {
		const {
			league_removed
		} = this.state;

		const {
			remove_league_success
		} = this.props;

		return league_removed && remove_league_success;

	}

	get is_created() {
		const {
			from,
			league_create: {
				league_id
			},
			clearDraftLeagueCreateErrors
		} = this.props;

		if(from === 'update') {
			return null;
		}

		if(league_id){
			clearDraftLeagueCreateErrors();
			return <Redirect to={`/league/${league_id}/invite`} />;
		}
	}

	get check_is_locked_game() {
		const { actual_round, from } = this.props;

		return actual_round.id === 25 && actual_round.status === 'complete' && from === 'create';
	}

	render() {
		const rounds_list = this.getRoundOptions();

		if(this.should_redirect_to_leagues) {
			return <Redirect to='leagues' />;
		}

		if (_.isEmpty(rounds_list)) {
			return <Preloader />;
		}

		if (this.check_is_locked_game) {
			return (
				<OneColumnLayout>
					<AlertScreen
						text={'Leagues cannot be joined/created after Round 25 has begun.'}
					/>
				</OneColumnLayout>
			);
		}
		return this.render_page;
	}

	get render_page() {
		const rounds_list = this.getRoundOptions();

		const { league_update, league_create } = this.props;
		const {
			show_remove_modal,
			league_updated,
		} = this.state;
		return (
			<React.Fragment>
				{ this.is_created }
				{ league_update.error || league_create.error ? this.error_modal : null }
				{ show_remove_modal ? this.remove_modal : null }
				{ league_updated ? this.updated_modal : null }
				{
					this.props.children({
						rounds_list,
						handleSubmit: this.handler_name,
						onChangeFile: this.onChangeFile,
						toggleForm: this.toggleForm,
						removeLeague: this.removeLeague,
						...this.props,
						...this.state,
					})
				}
			</React.Fragment>
		);
	}
}

const selector = formValueSelector('league_manager');

const mapStateToProps = (state, props) => {
	const
		{ league = {} } = props,
		{ status } = league,
		ownProps = {
			is_bye: selector(state, 'bye_rounds') === 1,
			selected_round_id: selector(state, 'start_round'),
			league,
		},
		rounds_by_id = state.rounds.by_id,
		selected_round_id = ownProps.selected_round_id ?
			ownProps.selected_round_id :
			getLeagueStartRounds(state, ownProps).selected_round_id,
		selected_round = rounds_by_id[selected_round_id];
	let rounds = getLeagueStartRounds(state, ownProps).rounds;

	if (status && status !== 'scheduled' && !_.isEmpty(rounds_by_id)) {
		rounds = [rounds_by_id[league.start_round]];
	}
	return {
		league,
		league_update: state.leagues.update,
		league_create: state.leagues.create,
		remove_league_success: state.leagues.remove.success,
		rounds,
		rounds_by_id,
		selected_round,
		actual_round: selectors.rounds.getActualRound(state),
		selected_round_id,
		league_id: state.leagues.create.league_id,
	};
};

const mapDispatchToProps = {
	showDraftLeague: actions.leagueDraft.showDraftLeague,
	createDraftLeague: actions.leagueDraft.createDraftLeague,
	updateDraftLeague: actions.leagueDraft.updateDraftLeague,
	removeDraftLeague: actions.leagueDraft.removeDraftLeague,
	clearDraftLeagueCreateErrors: actions.leagueDraft.clearDraftLeagueCreateErrors,
	clearDraftLeagueUpdateErrors: actions.leagueDraft.clearDraftLeagueUpdateErrors,
	fetchRounds: actions.rounds.fetchRounds,
};

export const LeagueManagerComponent = withRouter(connect(
	mapStateToProps,
	mapDispatchToProps
)(LeagueManager));

export default LeagueManagerComponent;


// WEBPACK FOOTER //
// ./src/components/utils/LeagueManager/index.js